import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { HubspotRegistration } from './HubspotRegistration';

export const RegisterToHubspotComponents: FormDrawerProps<ZodSchema<unknown>> = {
  ContentComponent: HubspotRegistration,
};
